export default ( () => {

    jQuery( document ).ready( function( $ ) {

        $.fn.COTAccordion = function( params ) {

            const _this = this;

            $( '.accordion-button--expand', this ).on( 'click', function( event ) {
            
                event.preventDefault()

                _this.onPressExpandAll()

            })

            $( '.accordion-button--collapse', this ).on( 'click', function( event ) {
            
                event.preventDefault()

                _this.onPressCollapseAll()

            } )

            _this.onPressCollapseAll = function() {

                // event.preventDefault()

                // console.log( "Collapse All Accordions" );

                const accordionHeader = $( '.accordion-button', this );

                const accordionContent = $( '.accordion-collapse', _this );

                // accordionHeader.attr( 'aria-expanded', false ).addClass( 'collapsed' )

                // accordionContent.removeClass( 'show' );

                const parent = _this.closest( '.cot-blocks--accordion' )

                jQuery( '.accordion-collapse.collapse' ).collapse('hide');

            }

            _this.onPressExpandAll = function() {

                // event.preventDefault()

                // console.log( "Expand All Accordions" );

                // console.log( "Expand This: \n", this );

                // const accordionHeader = $( '.accordion-button', this );

                // const accordionContent = $( '.accordion-collapse', _this );

                const parent = _this.closest( '.cot-blocks--accordion' )

                jQuery( '.accordion-collapse.collapse' ).collapse('show');

                // accordionHeader.attr( 'aria-expanded', true ).removeClass( 'collapsed' )

                // accordionContent.addClass( 'show' );

            }

        }

        $( '.cot-blocks--accordion' ).each(( index, element ) => {
        
            $( element ).COTAccordion();

        });

    });

} )()